const getShoppingErrorMessages = ({ statusList = []}) =>
  statusList.map(({ code, description: message }) => ({ code, message, visible: true }))

export default getShoppingErrorMessages
